import { useTranslation } from 'react-i18next';
import { Checkbox } from '@components/ui/Checkbox/Checkbox';
import styles from './PrivateField.module.css';

interface IPrivateFieldProps {
  value: boolean;
  onChange: (v: boolean) => void;
}

const LockIcon = () => (
  <svg
    viewBox="0 0 16 16"
    width="12"
    height="12"
    stroke="currentColor"
    strokeWidth="1.5"
    fill="none"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <rect x="3" y="7" width="10" height="7" rx="1" />
    <path d="M5 7V5a3 3 0 0 1 6 0v2" />
  </svg>
);

export function PrivateField({ value, onChange }: IPrivateFieldProps) {
  const { t } = useTranslation();
  return (
    <label className={styles.wrapper} aria-label={t('issues.field.privateLabel')}>
      <Checkbox
        checked={value}
        onCheckedChange={onChange}
        ariaLabel={t('issues.field.privateLabel')}
      />
      <span className={styles.lockIcon}>
        <LockIcon />
      </span>
      <span className={styles.label}>{t('issues.field.privateLabel')}</span>
      <span className={styles.hint}>{t('issues.field.privateHint')}</span>
    </label>
  );
}
